export default {
    padding: 2,
    sizes: {
        md: 61,
        lg: 71,
    },
};
